import axios from "axios";

// Libs
import {getTokenFromLocalStorage} from "../auth/auth";
import utilsLib from "../common/libs/utils-lib";

// Constants
export const FETCH_TECHNICALS_SHEETS_REQUEST = "FETCH_TECHNICALS_SHEETS_REQUEST";
export const FETCH_TECHNICALS_SHEETS_SUCCESS = "FETCH_TECHNICALS_SHEETS_SUCCESS";
export const FETCH_TECHNICALS_SHEETS_ERROR = "FETCH_TECHNICALS_SHEETS_ERROR";
export const CLEAN_TECHNICALS_SHEETS_STATE = "CLEAN_TECHNICALS_SHEETS_STATE";

export const readTechnicalsSheets = (filters = {}) => {
    return async (dispatch) => {
        try {
            dispatch(fetchTechnicalsSheetsRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.post('/api/technicals-sheets', {filters}, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, fetchTechnicalsSheetsSuccess, fetchTechnicalsSheetsError));
        } catch (err) {
            dispatch(utilsLib.response(err, fetchTechnicalsSheetsError));
        }
    };
};

const fetchTechnicalsSheetsRequest = () => {
    return {
        type: FETCH_TECHNICALS_SHEETS_REQUEST
    };
};

const fetchTechnicalsSheetsSuccess = (payload) => {
    return {
        type: FETCH_TECHNICALS_SHEETS_SUCCESS,
        payload
    };
};

const fetchTechnicalsSheetsError = (errorMessage) => {
    return {
        type: FETCH_TECHNICALS_SHEETS_ERROR,
        errorMessage
    };
};

export const cleanTechnicalsSheetsState = () => {
    return {
        type: CLEAN_TECHNICALS_SHEETS_STATE
    }
}